var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('weui-group',{attrs:{"title":((_vm.formatDate(_vm.draft.date)) + " 可供预约课程的时段：")}},_vm._l((_vm.formatted_available_times),function(t){return _c('weui-cell',{key:t,staticStyle:{"text-align":"center"},on:{"click":function($event){_vm.selectTime(t)}}},[_vm._v(_vm._s(t))])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35a94370","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/course/TimeSelector.vue
// module id = null
// module chunks = 